export const NEW_PASSWORD_REQUIRED = "NEW_PASSWORD_REQUIRED";
export const SMS_MFA = "SMS_MFA";
export const SOFTWARE_TOKEN_MFA = "SOFTWARE_TOKEN_MFA";
export const MFA_SETUP = "MFA_SETUP";
export const SELECT_MFA_TYPE = "SELECT_MFA_TYPE";
export const CUSTOM_AUTH = "CUSTOM_AUTH";
export const CUSTOM_CHALLENGE = "CUSTOM_CHALLENGE";
export const USER_PASSWORD_AUTH = "USER_PASSWORD_AUTH";
